// @flow

import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';

type EventEntry = {|
  event: string,
  permissions: Array<String>,
|};

type Props = {|
  events: Array<EventEntry>,
  children: React.Node,
|};

export const EventPermissionTable = ({events}: Props) => {
  if (!events) {
    return null;
  }

  return (
    <Table type="striped">
      <thead>
        <tr>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.EventPermisssionTable.eventHeader"
              defaultMessage="Event"
            />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.EventPermisssionTable.permissionHeader"
              defaultMessage="Permission"
            />
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {events.map((entry) => (
          <tr>
            <TableCell>
              <code className="InlineCode">{entry.event}</code>
            </TableCell>
            <TableCell>
              {entry.permissions.map((permission, i) => {
                return (
                  <>
                    <code className="InlineCode">{permission}</code>
                    {i < entry.permissions.length - 1 && (
                      <>
                        <span>{','}</span>
                        <br />
                      </>
                    )}
                  </>
                );
              })}
            </TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
